import { Action, createReducer, on } from '@ngrx/store';
import { PlatformTypeEnum } from '@shared/enums/platform-type.enum';
import { PlatformStateModel } from '@shared/models/platform-state.model';
import {
  loadAdvisorUserData,
  loadAdvisorUserDataFailure,
  loadAdvisorUserDataSuccess,
  setPlatformType,
} from '@shared/store/platform/platform.actions';
import { companyTypeToPlatformType } from '@shared/utils/company-type-to-platform-type';

const initialPlatformState: PlatformStateModel = {
  adviserUser: null,
  company: null,
  network: null,
  platformType: PlatformTypeEnum.Adviser,
  loaded: false,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialPlatformState,

  on(
    setPlatformType,
    (state, { platformType }): PlatformStateModel => ({
      ...state,
      platformType,
    }),
  ),

  on(
    loadAdvisorUserData,
    (state): PlatformStateModel => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),

  on(
    loadAdvisorUserDataSuccess,
    (state, { response }): PlatformStateModel => ({
      ...state,
      loading: false,
      loaded: true,
      adviserUser: response.advisorUser ?? null,
      company: response.company ?? null,
      network: response.network ?? null,
      platformType: response.company?.companyType ? companyTypeToPlatformType(response.company.companyType) : state.platformType,
    }),
  ),

  on(
    loadAdvisorUserDataFailure,
    (state, { error }): PlatformStateModel => ({
      ...state,
      loading: false,
      error,
    }),
  ),
);

export const platformReducer = (state: PlatformStateModel = initialPlatformState, action: Action): PlatformStateModel =>
  reducer(state, action);
